import React from 'react';
import { NavLink } from 'react-router-dom';
import { UilBriefcase } from '@iconscout/react-unicons';
import { useTranslation } from 'react-i18next';

export const getUsersMenuItems = (basePath, toggleCollapsed, topMenu) => {
  const { t } = useTranslation();
  return [
    {
      key: 'users',
      label: t('Users'),
      icon: !topMenu && <UilBriefcase size={20} />,
      children: [
        {
          key: 'users-add',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/user/registration`}>
              {t('Add User')}
            </NavLink>
          ),
        },
        {
          key: 'users-list',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/user/list`}>
              {t('Users List')}
            </NavLink>
          ),
        },
      ],
    },
  ];
};
